import { render } from "./CategorizedFAQ.vue?vue&type=template&id=64391fe7&scoped=true"
import script from "./CategorizedFAQ.vue?vue&type=script&lang=js"
export * from "./CategorizedFAQ.vue?vue&type=script&lang=js"

import "./CategorizedFAQ.vue?vue&type=style&index=0&id=64391fe7&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-64391fe7"

export default script